/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
});


// DEV-888
if(jQuery('.newsletter-submit').length) {
  jQuery('.newsletter-submit').click(function() {
  	debugger;
    jQuery('#newsletter-email-input').removeClass('is-invalid-input');
    jQuery('#privacy-consent-newsletter-container').removeClass('label-error');
    jQuery('#newsletter-email-error').hide();
    jQuery('#signupSuccessModal').hide();
    var that = this;
    jQuery(this).addClass('processing');
    var params = {act: 'signup-newsletter', source: 'chronicles', consent: jQuery('#privacy_consent_newsletter:checked').val(), email : jQuery('#newsletter-email-input').val()};

    if (jQuery(this).hasClass('men')) {
      var extraFields = {men:1, wmns:0};
      params.extra_fields = JSON.stringify(extraFields);
    } else if (jQuery(this).hasClass('wmns')) {
      var extraFields = {men:0, wmns:1};
      params.extra_fields = JSON.stringify(extraFields);
    }

    if (jQuery('#privacy_consent_newsletter:checked').length > 0) {
      params['consent'] = jQuery('#privacy_consent_newsletter:checked').val()
    }
    jQuery.ajax({
      type: "POST",
      url: jQuery(this).attr('data-target'),
      data : params,
      async: true
    }).done(function(response) {
      jQuery(that).removeClass('processing');
      var response = JSON.parse(response);
      if(response.success) {
        jQuery('#newsletter-email-input').val('');
        jQuery('#signupSuccessModalContent').html(response.message);
        jQuery('#signupSuccessModal').foundation('open');;
      } else {
        if(response.field) {
          switch(response.field) {
            case 'email':
              jQuery('#newsletter-email-input').addClass('is-invalid-input');
            break;
            case 'consent':
              jQuery('#privacy-consent-newsletter-container').addClass('label-error');
            break;
          }
        }
        jQuery('#newsletter-email-error').html('<small>' + response.message + '</small>');
        jQuery('#newsletter-email-error').show();
      }
    });
  });
}



// open/close on offcanvas area
var btn = jQuery('.offcanvas-full-screen');
btn.on('opened.zf.offcanvas', function() {
  jQuery('.btn').addClass('active');
  jQuery('.hamburger').addClass('active');
  jQuery('.btn').removeClass('not-active');
});
btn.on('closed.zf.offcanvas', function() {
  jQuery('.btn').addClass('not-active');
  jQuery('.hamburger').removeClass('active');
  jQuery('.btn').removeClass('active');
});

// slick slider for sticky posts
jQuery('.slickslider').slick({
  dots: true,
  arrows: true,
  speed: 400
});
